import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btn-wrap" }
const _hoisted_2 = { class: "statewords" }
const _hoisted_3 = { class: "btn-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dformVue = _resolveComponent("dformVue")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "dform_head" }, [
        _createElementVNode("div", { class: "dform_head_l" }, [
          _createElementVNode("div", { class: "dform_head_title_befor" }),
          _createElementVNode("div", { class: "dform_head_title" }, "生源信息")
        ])
      ], -1)),
      (_ctx.showTalent)
        ? (_openBlock(), _createBlock(_component_dformVue, {
            key: 0,
            formconfig: _ctx.schema,
            data: _ctx.dataTalent
          }, null, 8, ["formconfig", "data"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dform_head" }, [
        _createElementVNode("div", { class: "dform_head_l" }, [
          _createElementVNode("div", { class: "dform_head_title_befor" }),
          _createElementVNode("div", { class: "dform_head_title" }, "签约信息")
        ])
      ], -1)),
      _createVNode(_component_dformVue, {
        class: "step2",
        formconfig: _ctx.signForm,
        data: _ctx.dataSign
      }, null, 8, ["formconfig", "data"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.isShowNOPass), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.amend()))
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("修改")
          ])),
          _: 1,
          __: [2]
        })
      ])
    ])
  ], 64))
}